import {
  CommissionType,
  PaginatedResponse,
  PartnerAffiliation,
  PartnerProgramConfig,
  PartnerProgramConfigPayload,
} from '@/@types/PartnerProgram';
import { api } from './api';

export interface PartnerInviteDetailsResponse {
  id: string;
  product: {
    id: string;
    name: string;
    producer_name: string;
    images: { url: string }[];
  };
  commission_type: CommissionType;
  commission_value: number;
  commission_value_formatted?: string;
  commission_currency: string;
  is_lifetime: boolean;
  duration_days: number | null;
}

// Buscar configuração do programa de parceiros
async function getPartnerProgram(
  productUuid: string,
): Promise<{ data: PartnerProgramConfig }> {
  const response = await api.get(
    `/v1/products/${productUuid}/partner-program`,
  );
  return response.data;
}

// Salvar/atualizar configuração do programa de parceiros
async function savePartnerProgram(
  productUuid: string,
  data: PartnerProgramConfigPayload,
): Promise<{ data: PartnerProgramConfig }> {
  const response = await api.post(
    `/v1/products/${productUuid}/partner-program`,
    data,
  );
  return response.data;
}

// Listar parceiros indicadores com métricas
async function listPartners(
  productUuid: string,
  params?: {
    only_active?: boolean;
    per_page?: number;
    page?: number;
    currency?: string;
  },
): Promise<PaginatedResponse<PartnerAffiliation>> {
  const response = await api.get(
    `/v1/products/${productUuid}/partner-program/partners`,
    { params },
  );
  return response.data;
}

// Vincular parceiro ao produto por e-mail
async function attachPartner(
  productUuid: string,
  partnerEmail: string,
): Promise<{ message: string }> {
  const response = await api.post(
    `/v1/products/${productUuid}/partner-program/partners`,
    { partner_email: partnerEmail },
  );
  return response.data;
}

// Desativar parceiro indicador
async function deactivatePartner(
  productUuid: string,
  partnerUuid: string,
): Promise<{ message: string }> {
  const response = await api.delete(
    `/v1/products/${productUuid}/partner-program/partners/${partnerUuid}`,
  );
  return response.data;
}

// Atualizar comissão de um parceiro específico
async function updatePartnerCommission(
  productUuid: string,
  partnerUuid: string,
  data: {
    commission_type: CommissionType;
    commission_value: number;
    commission_currency: string;
  },
): Promise<{ data: PartnerAffiliation }> {
  const response = await api.put(
    `/v1/products/${productUuid}/partner-programs/partners/${partnerUuid}/commission`,
    data,
  );
  return response.data;
}

async function getInvitePartnerProgramById(
  productId: string,
): Promise<PartnerInviteDetailsResponse> {
  const response = await api.get(
    `/v1/externals/${productId}/partner-program`,
  );
  return response.data.data;
}

async function applyPartnerProgram(
  productId: string,
): Promise<{ message: string }> {
  const response = await api.post(
    `/v1/externals/${productId}/partner-program`,
  );
  return response.data;
}

export const PartnerProgramService = {
  getPartnerProgram,
  savePartnerProgram,
  listPartners,
  attachPartner,
  deactivatePartner,
  updatePartnerCommission,
  getInvitePartnerProgramById,
  applyPartnerProgram,
};
